import {Tr} from "@/i18n/i18n";
import {VerticalStandardPanel} from "@/scenes.ui/vertical-standard-panel";
import Scene = Phaser.Scene;
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {Keys} from "@/constants/key";
import {TabbedPanel} from "@/scenes.ui/tabbed-panel";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";

export class HeroIntroPanel extends VerticalStandardPanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement, title: string, name: string, blockFirstTxt: string, blockSecondTxt: string) {
        super(scene, canvas, title);
        this.setDepth(TabbedPanel.DEPTH + 5000);

        let nameText = TextUtils.addTextByFamily(scene, name, 0, -190,
            '#ffd465', 18, 'bold', 450, Fonts.MYRIADPRO_REGULAR);

        let light = SpriteUtils.addSprite(this.scene, -135, -90, Keys.ATLAS_PROFILE, Keys.UI_ART_LIGHT);
        let icon = SpriteUtils.addSprite(this.scene, -150, -100, Keys.ATLAS_CREATURES_BATTLE_1, 'myth-phoenix');

        let blockFirst = TextUtils.addTextAdvanced(scene, blockFirstTxt, 55, -90,
            '#a2ff82', 15, 'normal', 280, 'center', 2, Fonts.ARIAL_MT);

        let blockSecond = TextUtils.addTextByFamily(scene, blockSecondTxt,
            0, blockFirst.y / CU.S + 105, '#ff9b65', 15, 'normal', 400, Fonts.ARIAL_MT);

        this.add([nameText, light, icon, blockFirst, blockSecond]);

        this.addCloseButton(Tr('horosho'), () => {});
    }

    protected onClose(): void {

    }

}
